import { FC, ReactNode } from "react";

type Props = {
  title: string;
  description: string;
  icon: ReactNode;
  onSelect: () => void;
  disabled?: boolean;
};

const SuggestedPromptCard: FC<Props> = ({
  title,
  description,
  icon,
  onSelect,
  disabled
}) => (
  <button
    type="button"
    onClick={onSelect}
    disabled={disabled}
    className="flex h-full w-full flex-col gap-3 rounded-xl border border-gainsboro bg-white p-[18px] text-left transition-colors hover:border-teal-300 hover:bg-teal-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-gainsboro disabled:hover:bg-white"
    data-testid={`agentic-ai-suggested-prompt-${title.toLowerCase().replace(/\s/g, "-")}`}
  >
    <span aria-hidden className="[&>svg]:h-6 [&>svg]:w-6 [&>svg]:fill-dim-gray">
      {icon}
    </span>
    <span className="text-base font-semibold text-txtHeading">{title}</span>
    <span className="text-xs leading-relaxed text-txtBody">{description}</span>
  </button>
);

export default SuggestedPromptCard;
